import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import formatDate from '../../utils/formatDate';
import TopicListItemUserList from './TopicListItemUserList';
import paths from '../../paths';

export default class TopicListItem extends Component {
  static propTypes = {
    topic: PropTypes.shape({
      id: PropTypes.number.isRequired,
      alias: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      isOpen: PropTypes.bool.isRequired,
      totalComments: PropTypes.number.isRequired,
      createDate: PropTypes.string.isRequired,
      userId: PropTypes.string.isRequired,
      lastCommentUserIds: PropTypes.array.isRequired,
      hasUnreadComments: PropTypes.bool.isRequired,
      users: PropTypes.array
    }).isRequired,
  };

  render() {
    const {
      id, isOpen, alias, title, totalComments, createDate, userId, hasUnreadComments, lastCommentUserIds, users
    } = this.props.topic;
    return (
      <div className={classNames('themes-list__row', { 'themes-list__row--unread': hasUnreadComments })}>
        <div className="themes-list__item themes-list__item--icon">
          <i
            className={classNames('themes-list__icon', { 'themes-list__icon--locked': !isOpen })}
          />
        </div>
        <div className="themes-list__item themes-list__item--title">
          <Link to={`${paths.advocates.forumTopic}/${alias}`} className="themes-list__theme-title">
            {title}
          </Link>
        </div>
        <div className="themes-list__item themes-list__item--date -mobile-hide">
          <time className="date" dateTime="2017-06-30 13:37">
            <span className="nowrap">{formatDate(createDate, 'DD MMMM YYYY')}</span>&nbsp;
            <span className="nowrap">{formatDate(createDate, 'HH:mm')}</span>
          </time>
        </div>
        <div className="themes-list__item themes-list__item--theme-messages">
          <div className="count">{totalComments}</div>
        </div>
        {users &&
          <TopicListItemUserList topicCreator={userId} users={users} />
        }
      </div>
    );
  }
}
